import React from 'react';

function Error404() {
    return <h1>Page not Found</h1>;
}

export default Error404;